import React from "react";
import { DefaultSpinner, NoData } from "components";
import type { ScopedLocationIds } from "hooks/useAdminGroup/useScopedLocationIds";

interface LocationScopeGateProps {
  scope: ScopedLocationIds;
  children: React.ReactNode;
}

// Shared gate every scope-aware widget renders through. A failed hierarchy
// load never reaches this gate: useScopedWayfinderSelection fails open to
// NO_SCOPE (see the rationale there), so widgets render unscoped instead of
// erroring. Ordering matters: loading is checked before applyScope because
// while the LBA flag is still resolving with a stored selection, applyScope
// is not yet knowable and rendering would fire an unscoped request; and the
// empty-scope case is handled here so no request is ever sent with zero
// in-scope locations -- whether the backend treats an empty filter as "no
// rows" or "no filter" must never decide what a scoped admin sees.
const LocationScopeGate = ({ scope, children }: LocationScopeGateProps) => {
  if (scope.isLoading) return <DefaultSpinner />;

  if (!scope.applyScope) return <>{children}</>;

  if (scope.scopeExternalIds.size === 0) {
    return (
      <NoData description="The selected admin group has no locations or sub-groups to scope by. Choose a different scope from the breadcrumb." />
    );
  }

  return <>{children}</>;
};

export default LocationScopeGate;
